module.exports = typeof Object.entries === 'function' ? Object.entries : require('./entries')
